import { SrcExamResultComponent } from './modules/examinee/inspection-result/src-exam-result/src-exam-result.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './modules/home/home.component';
import { ShellService } from './layout/shell-service/shell.service';
import { ExampleComponent } from './modules/example/example.component';
import { HtmlCssComponent } from './modules/example/html-css/html-css.component';
import { ScrExamToppageComponent } from './modules/examinee/toppage/scr-exam-toppage/scr-exam-toppage.component';
import { SrcExamLoginComponent } from './modules/examinee/auth/src-exam-login/src-exam-login.component';
import { SrcPwForgotComponent } from './modules/examinee/auth/src-pw-forgot/src-pw-forgot.component';
import { SrcPwResetComponent } from './modules/examinee/auth/src-pw-reset/src-pw-reset.component';
import { SrcInterviewComponent } from './modules/interview/src-interview.component';
import { SrcInsuranceSelComponent } from './modules/examinee/reservation-regis/src-insurance-sel/src-insurance-sel.component';
import { SrcInsuranceInpComponent } from './modules/examinee/reservation-regis/src-insurance-inp/src-insurance-inp.component';
import { SrcExamCourseSelComponent } from './modules/examinee/reservation-regis/src-exam-course-sel/src-exam-course-sel.component';
import { SrcReservationDateSelComponent } from './modules/examinee/reservation-regis/src-reservation-date-sel/src-reservation-date-sel.component';
import { SrcReservationDetailComponent} from './modules/examinee/reservation-regis/src-reservation-detail/src-reservation-detail.component';
import { ScrUserInfInpComponent } from './modules/examinee/auth/scr-user-inf-inp/scr-user-inf-inp.component';
import { ScrSendingAuthenMailComponent } from './modules/examinee/auth/scr-sending-authen-mail/scr-sending-authen-mail.component';
import { RoleGuardService } from './core/guard/role-guard.service';
import { ErrorNotFoundComponent } from './modules/error-not-found/error-not-found.component';
import { ScrExamInfInputComponent } from './modules/examinee/auth/scr-exam-inf-input/scr-exam-inf-input.component';
import { SrcPersonalInfComponent } from './modules/examinee/personal-inf/src-personal-inf.component';
import { SrcPersonalInfInpComponent } from './modules/examinee/reservation-regis/src-personal-inf-inp/src-personal-inf-inp.component';
import { LogoutComponent } from './layout/logout/logout.component';
import { SrcQuestionareAnsInpComponent } from './modules/examinee/questionare-inp/src-questionare-ans-inp/src-questionare-ans-inp.component';
import { DeactivateGuard } from './can-deactivate-guard.service';
import { BookingTermsComponent } from './modules/terms-conditions/booking-terms.component';
import { ServiceTermsComponent } from './modules/terms-conditions/service-terms.component';
const routes: Routes = [
  {
    path: 'booking-terms',
    component: BookingTermsComponent
  },
  {
    path: 'service-terms',
    component: ServiceTermsComponent
  },
  ShellService.childRoutesPublic([ // Router add here if don't need login
    {
      path: 'home',
      component: HomeComponent,
    },
    {
      path: 'example',
      component: ExampleComponent
    },
    {
      path: 'html-css',
      component: HtmlCssComponent
    },
    {
      path: 'toppage',
      component: ScrExamToppageComponent,
      canActivate: [RoleGuardService],
    },
    {
      path: 'src-exam-login',
      component: SrcExamLoginComponent,
    },
    {
      path: '',
      component: SrcExamLoginComponent,
      canActivate: [RoleGuardService],
    },
    {
      path: 'src-pw-forgot',
      component: SrcPwForgotComponent
    },
    {
      path: 'src-pw-reset',
      component: SrcPwResetComponent
    },
    {
      path: 'src-interview',
      component: SrcInterviewComponent
    },
    {
      path: 'insurance-sel',
      component: SrcInsuranceSelComponent,
      canActivate: [RoleGuardService],
    },
    {
      path: 'insurance-inp',
      component: SrcInsuranceInpComponent,
      canActivate: [RoleGuardService],
      canDeactivate: [DeactivateGuard]
    },
    {
      path: 'exam-course-sel',
      component: SrcExamCourseSelComponent,
      canActivate: [RoleGuardService],
      canDeactivate: [DeactivateGuard]
    },
    {
      path: 'reservation-date-sel',
      component: SrcReservationDateSelComponent,
      canActivate: [RoleGuardService],
      canDeactivate: [DeactivateGuard]
    },
    {
      path: 'personal-inf-inp',
      component: SrcPersonalInfInpComponent,
      canActivate: [RoleGuardService],
      canDeactivate: [DeactivateGuard]
    },
    {
      path: 'reservation-detail',
      component: SrcReservationDetailComponent,
      canActivate: [RoleGuardService],
      canDeactivate: [DeactivateGuard]
    },
    {
      path: 'user-inf-inp',
      component: ScrUserInfInpComponent
    },
    {
      path: 'scr-exam-result',
      component: SrcExamResultComponent
    },
    {
      path: 'sending-authen-mail',
      component: ScrSendingAuthenMailComponent
    },
    {
      path: '404',
      component: ErrorNotFoundComponent
    },
    {
      path: 'login',
      component: SrcExamLoginComponent,
      canActivate: [RoleGuardService],
    },
    {
      path: 'scr-exam-inf-input',
      component: ScrExamInfInputComponent
    },
    {
      path: 'src-personal-inf',
      component: SrcPersonalInfComponent,
      canActivate: [RoleGuardService],
      canDeactivate: [DeactivateGuard]
    },
    {
      path: 'logout',
      component: LogoutComponent
    },
    {
      path: 'scr-questionare-ans-inp',
      component: SrcQuestionareAnsInpComponent,
      canActivate: [RoleGuardService],
      canDeactivate: [DeactivateGuard]
    },
    {
      path: '**',
      component: ErrorNotFoundComponent
    }
  ]),
  ShellService.childRoutes([ // Router add here if need login

  ]),
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
